import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.skills')
  .factory('SkillsAPI', SkillsAPI);

function SkillsAPI(): BringozApi {
  return {
    base: `/settings/skills`,
    infiniteScroll: {
      address: `/settings/skills`,
      cmd: 'GET'
    },
    actions: {
      getAll: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}
